/**
 * 判断是否已读
 */
'use strict';
angular.module('msgServiceModule', [])
    .factory('msgService', ["$q", "trsHttpService", function($q, trsHttpService) {
        return {
            /**
             * hasRead 判断是否已读
             * @param {} item 
             */
            gotoDetail: function(item) {
                let defer = $q.defer();
                let params = {
                    messageid: item.messageid,
                    serviceid: "message",
                    method: "findmessagebyid"
                };
                trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, "GET").then(function(data) {
                    defer.resolve(data);
                });
                return defer.promise;
            },
            readType: {
                0: "未读",
                1: "已读"
            }, //消息类型

        };
    }]).factory('alertDetailModule', ['$modal', function($modal) {
        return {
            alertDeatil: function(hostUrl) {
                var modalInstance = $modal.open({
                    templateUrl: "./MC/message/service/alertDetail.html",
                    windowClass: 'propaganda-detail',
                    backdrop: false,
                    controller: "supportAlertDetailCtrl",
                    resolve: {
                        hostUrl: function() {
                            return hostUrl;
                        }
                    }
                });
            }
        };
    }]).controller('supportAlertDetailCtrl', ['$scope', 'trsHttpService', '$sce', 'hostUrl', '$modalInstance', '$http', function($scope, trsHttpService, $sce, hostUrl, $modalInstance, $http) {
        initstatus();
        initdata();

        function initstatus() {}

        function initdata() {
            trsHttpService.httpServer(hostUrl, '', 'get').then(function(data) {
                data.data ? $scope.detail = data.data.document : $scope.detail = data;
            });
        }
        $scope.close = function() {
            $modalInstance.close();
        };
    }]);